import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-su-helpers-list',
  templateUrl: './su-helpers-list.component.html',
  styleUrls: ['./su-helpers-list.component.css'],
  host: {
    class: 'fill-screen-modal-new-dialog'
  }
})
export class SuHelpersListComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  clusters: any[] = [];

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    // Fetch helpers list from backend
    this.fetchHelpersList();
  }

  fetchHelpersList() {
    const url = `${environment.apiUrl}/clusters/helpers-list`;
    this.http.get<{ message: string; clusters: any[] }>(url).subscribe({
      next: (response) => {
        if (response.clusters) {
          this.clusters = response.clusters;
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching helpers list:', error);
        this.isLoading = false;
      }
    });
  }

  formatPhoneNumber(phone: number): string {
    if (!phone) {
      return '';
    }
    const phoneStr = '0' + phone.toString();
    return `${phoneStr.slice(1, 3)}-${phoneStr.slice(3, 7)}-${phoneStr.slice(7)}`;
  }

  closeSuHelpersListDialog() {
    this.dialogService.onCloseSuHelpersListDialog();
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }
}
